export default __webpack_public_path__ + "static/media/logojose02.0387ee72.svg";